import { FC } from 'react';
import { Card, CardContent } from '../ui/card';
import { LessonMedia } from './LessonMedia';

interface LessonContentSectionProps {
  videoUrl: string;
  audioUrl: string;
  contentText: string;
  lessonId: string;
}

export const LessonContentSection: FC<LessonContentSectionProps> = ({
  videoUrl,
  audioUrl,
  contentText,
  lessonId,
}) => {
  return (
    <Card className="mb-8 shadow-lg animate-fade-in bg-gradient-to-br from-white to-primary/5">
      <CardContent className="p-6">
        <LessonMedia
          videoUrl={videoUrl}
          audioUrl={audioUrl}
          contentText={contentText}
          lessonId={lessonId}
        />
      </CardContent>
    </Card>
  );
};